import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FileUploadItem } from '@shs-digi-care-monorepo/frontend-lib';

export interface OverviewFormGroup {
    subject: FormControl<string | null>;
    shipmentRequiredByDate: FormControl<string | null>;
    reason: FormControl<string | null>;
    files: FormControl<FileUploadItem[] | null>;
    isUrgent: FormControl<boolean>;
    emailHidingEnabled: FormControl<boolean>;
    informationalOnly: FormControl<boolean>;
    directReferOutInternal: FormControl<boolean>;
    directReferOutExternal: FormControl<boolean>;
}

export const createOverviewFormGroup = (): FormGroup<OverviewFormGroup> => {
    return new FormGroup<OverviewFormGroup>({
        subject: new FormControl<string | null>(null, [Validators.required]),
        shipmentRequiredByDate: new FormControl<string | null>(null),
        reason: new FormControl<string | null>(null),
        files: new FormControl<FileUploadItem[] | null>(null),
        isUrgent: new FormControl<boolean>(false, { nonNullable: true }),
        emailHidingEnabled: new FormControl<boolean>(false, { nonNullable: true }),
        informationalOnly: new FormControl<boolean>(false, { nonNullable: true }),
        directReferOutInternal: new FormControl<boolean>(false, { nonNullable: true }),
        directReferOutExternal: new FormControl<boolean>(false, { nonNullable: true })
    });
};
